//////// 3.4 GHG EFSchema
const threeFourSchema = {
  title: "3.4 Upstream Transportation and Distribution",
  cat: "3_1",
  catName: "cat3",
  progressiveOrderSwitch: {
    by: { level: 8, key: "sourceEFName" },
  },
  fields: [
    {
      key: "title",
      type: "title",
      title: "Emission Factor",
      specialDataShouldIf: {
        level: 2,
        key: "calculationId",
        notEmpty: true,
        formData: "EAFormData",
      },
    },
    //////// Data Source
    {
      key: "emissionFactorTypeId",
      level: 7,
      type: "select",
      label: "Data Source",
      optionsAPI: "emissionFactorDropdown",
      autoFillNum: 0,
      specialDataShouldIf: {
        level: 2,
        key: "calculationId",
        notEmpty: true,
        formData: "EAFormData",
      },
    },
    ////////Emission Factor Database Source
    {
      key: "sourceEFName",
      level: 8,
      type: "select",
      label: "Emission Factor Database Source",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 7,
        key: "emissionFactorTypeId",
      },
      showIf: {
        all: [
          { level: 7, key: "emissionFactorTypeId", ne: "2" },
          { level: 7, key: "emissionFactorTypeId", notEmpty: true },
        ],
      },
      combineKey: 1,
    },
    //////////////// 第一種情況
    //////// Fuel Type
    {
      key: "fuelTypeOrVehicleCategory",
      level: 10,
      type: "select",
      label: "Fuel Type",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 8,
        key: "sourceEFName",
      },
      showIf: {
        level: 8,
        key: "sourceEFName",
        notEmpty: true,
      },
      specialDataShouldIf: {
        level: 2,
        key: "calculationId",
        eq: 3,
        formData: "EAFormData",
      },
      combineKey: 2,
    },
    //////// Fuel Name
    {
      key: "emissionFactorId",
      level: 11,
      type: "select",
      label: "Fuel Name",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 10,
        key: "fuelTypeOrVehicleCategory",
      },
      showIf: {
        all: [{ level: 10, key: "fuelTypeOrVehicleCategory", notEmpty: true }],
      },
      specialDataShouldIf: {
        level: 2,
        key: "calculationId",
        eq: 3,
        formData: "EAFormData",
      },
      combineKey: 3,
    },
    //////////////// 第二種情況
    //////// Transport Model
    {
      key: "transportModel",
      level: 9,
      type: "select",
      label: "Transport Model",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 8,
        key: "sourceEFName",
      },
      showIf: {
        level: 8,
        key: "sourceEFName",
        notEmpty: true,
      },
      specialDataShouldIf: {
        level: 2,
        key: "calculationId",
        eq: 2,
        formData: "EAFormData",
      },
      combineKey: 2,
    },
    //////// Vehicle Category
    {
      key: "fuelTypeOrVehicleCategory",
      level: 10,
      type: "select",
      label: "Vehicle Category",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 9,
        key: "transportModel",
      },
      showIf: {
        level: 9,
        key: "transportModel",
        notEmpty: true,
      },
      specialDataShouldIf: {
        level: 2,
        key: "calculationId",
        eq: 2,
        formData: "EAFormData",
      },
      combineKey: 3,
    },
    //////// Vehicle Type
    {
      key: "emissionFactorId",
      level: 11,
      type: "select",
      label: "Vehicle Type",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 10,
        key: "fuelTypeOrVehicleCategory",
      },
      showIf: {
        level: 10,
        key: "fuelTypeOrVehicleCategory",
        notEmpty: true,
      },
      specialDataShouldIf: {
        level: 2,
        key: "calculationId",
        eq: 2,
        formData: "EAFormData",
      },
      combineKey: 4,
    },
    ////////////////第三種情況
    //////// Transport Model
    {
      key: "transportModel",
      level: 9,
      type: "select",
      label: "Transport Model",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 8,
        key: "sourceEFName",
      },
      showIf: {
        level: 8,
        key: "sourceEFName",
        notEmpty: true,
      },
      specialDataShouldIf: {
        level: 2,
        key: "calculationId",
        eq: 1,
        formData: "EAFormData",
      },
      combineKey: 2,
    },
    //////// Vehicle Category
    {
      key: "fuelTypeOrVehicleCategory",
      level: 10,
      type: "select",
      label: "Vehicle Category",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 9,
        key: "transportModel",
      },
      showIf: {
        level: 9,
        key: "transportModel",
        notEmpty: true,
      },
      specialDataShouldIf: {
        level: 2,
        key: "calculationId",
        eq: 1,
        formData: "EAFormData",
      },
      combineKey: 3,
    },
    //////// Vehicle Type
    {
      key: "emissionFactorId",
      level: 11,
      type: "select",
      label: "Vehicle Type",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 10,
        key: "fuelTypeOrVehicleCategory",
      },
      showIf: {
        level: 10,
        key: "fuelTypeOrVehicleCategory",
        notEmpty: true,
      },
      specialDataShouldIf: {
        level: 2,
        key: "calculationId",
        eq: 1,
        formData: "EAFormData",
      },
      combineKey: 4,
    },
    //////// 自定義
    {
      key: "emissionFactorId",
      addBtn: true,
      level: 11,
      type: "select",
      custom: true,
      label: "Emission Factor Name",
      optionsAPI: "cat3CustomEFDropdownList",
      showIf: {
        level: 7,
        key: "emissionFactorTypeId",
        eq: "2",
      },
      autoFillNum: 0,
    },
  ],
};

export default threeFourSchema;
